import React, { useState } from "react";
import { auth } from "../utils/firebase";
import {
  createUserWithEmailAndPassword,
  updateProfile,
  signInWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
} from "firebase/auth";
import useAuthUser from "../hooks/useAuthUser";

const AppBar = () => {
  const [showLogin, setShowLogin] = useState(false);
  const [showRegister, setShowRegister] = useState(false);
  const user = useAuthUser();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [nickname, setNickname] = useState("");
  const [error, setError] = useState("");

  const handleLoginClick = () => {
    setShowLogin(true);
    setShowRegister(false);
    setError("");
  };
  const handleRegisterClick = () => {
    setShowRegister(true);
    setShowLogin(false);
    setError("");
  };
  const handleClose = () => {
    setShowLogin(false);
    setShowRegister(false);
    setError("");
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await signInWithEmailAndPassword(auth, email, password);
      setShowLogin(false);
      setEmail("");
      setPassword("");
    } catch (err) {
      if (err.code === "auth/invalid-credential") {
        setError("帳號或密碼錯誤，請重新輸入或註冊新帳號。");
      } else {
        setError("登入失敗: " + err.message);
      }
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      await updateProfile(userCredential.user, { displayName: nickname });
      // 註冊後暫存 nickname 到 localStorage，供 UserDataContext 初始化用
      localStorage.setItem("register_nickname", nickname);
      // 強制 reload user 以確保 displayName 更新
      await userCredential.user.reload();
      setShowRegister(false);
      setEmail("");
      setPassword("");
      setNickname("");
    } catch (err) {
      if (err.code === "auth/email-already-in-use") {
        setError("此 Email 已被註冊，請直接登入或使用其他 Email。");
      } else {
        setError("註冊失敗: " + err.message);
      }
    }
  };

  const handleGoogleLogin = async () => {
    const provider = new GoogleAuthProvider();
    provider.setCustomParameters({ prompt: "select_account" });
    try {
      await signInWithPopup(auth, provider);
      setShowLogin(false);
      setEmail("");
      setPassword("");
    } catch (error) {
      setError("Google 登入失敗: " + error.message);
    }
  };

  return (
    <header className="fixed top-0 left-0 w-full h-14 bg-[#181c23] shadow-lg flex items-center justify-between z-[2001] px-6 border-b border-[#23272f] box-border">
      <div className="flex items-center gap-2.5">
        {/* <img
          src="/logo192.png"
          alt="Logo"
          className="h-9 w-9 rounded-lg shadow-md bg-[#23272f] border border-[#23272f]"
        /> */}
        <span className="font-bold text-[22px] text-amber-300 tracking-wider ml-1 drop-shadow">
          9Walker
        </span>
      </div>
      <div className="flex items-center gap-3">
        {user ? (
          <>
            <span className="text-white font-semibold">
              {user.displayName || user.email}
            </span>
            <button
              className="bg-red-600 text-white rounded-full px-4 py-1 text-sm font-semibold shadow-md transition-colors outline-none hover:bg-red-500 focus:bg-red-500 border border-[#23272f] ml-2"
              onClick={() => auth.signOut()}
            >
              登出
            </button>
          </>
        ) : (
          <>
            <button
              className="bg-amber-700 text-white rounded-full px-4 py-1 text-sm font-semibold shadow-md transition-colors outline-none hover:bg-amber-600 focus:bg-amber-600 border border-[#23272f]"
              onClick={handleLoginClick}
            >
              登入
            </button>
            <button
              className="bg-green-600 text-white rounded-full px-4 py-1 text-sm font-semibold shadow-md transition-colors outline-none hover:bg-green-500 focus:bg-green-500 border border-[#23272f]"
              onClick={handleRegisterClick}
            >
              註冊
            </button>
          </>
        )}
      </div>
      {showLogin && !user && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-[3000]">
          <div className="relative bg-white p-8 rounded shadow-md w-80">
            <h2 className="text-2xl mb-4 text-center">登入</h2>
            <form onSubmit={handleLogin}>
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full mb-2 p-2 border rounded"
                required
              />
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full mb-4 p-2 border rounded"
                required
              />
              <button
                type="submit"
                className="w-full bg-amber-700 text-white p-2 rounded"
              >
                登入
              </button>
              <button
                type="button"
                className="w-full bg-blue-600 text-white p-2 rounded mt-2"
                onClick={handleGoogleLogin}
              >
                Google 登入
              </button>
              {error && <div className="text-red-500 mt-2">{error}</div>}
            </form>
            <button
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-xl"
              onClick={handleClose}
              aria-label="關閉登入"
            >
              ×
            </button>
          </div>
        </div>
      )}
      {showRegister && !user && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-[3000]">
          <div className="relative bg-white p-8 rounded shadow-md w-80">
            <h2 className="text-2xl mb-4 text-center">註冊</h2>
            <form onSubmit={handleRegister}>
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full mb-2 p-2 border rounded"
                required
              />
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full mb-2 p-2 border rounded"
                required
              />
              <input
                type="text"
                placeholder="暱稱"
                value={nickname}
                onChange={(e) => setNickname(e.target.value)}
                className="w-full mb-4 p-2 border rounded"
                required
              />
              <button
                type="submit"
                className="w-full bg-green-600 text-white p-2 rounded"
              >
                註冊
              </button>
              {error && <div className="text-red-500 mt-2">{error}</div>}
            </form>
            <button
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-xl"
              onClick={handleClose}
              aria-label="關閉註冊"
            >
              ×
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default AppBar;
